/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketSubsidyDto } from '../../models/ticket-subsidy-dto';

export interface TicketSubsidyControllerFindPrevTicketSubsidy$Params {
  ticketId: string;
}

export function ticketSubsidyControllerFindPrevTicketSubsidy(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerFindPrevTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerFindPrevTicketSubsidy.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyDto>;
    })
  );
}

ticketSubsidyControllerFindPrevTicketSubsidy.PATH = '/api/ticket-subsidy/prev';
